import { IEntryStateScored } from "../models";
import { IElementTypeEditInfo } from './../models/index';

export interface IEntryStateCamera extends IEntryStateScored {
    url?: string;
}

export const cameraEditInfo = {
    editExcludeFields: []
}